import React, { useEffect } from "react";
import "./RestorationModal.css";

const RestorationModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="rm-overlay" onClick={onClose}>
      <div className="rm-container" onClick={(e) => e.stopPropagation()}>
        <button className="rm-close" onClick={onClose}>&times;</button>

        <div className="rm-content">
          {/* Left — Text */}
          <div className="rm-text">
            <h1>THE MODERN HEALTH AND NUTRITION GAP</h1>

            <p>
              Advances in medicine and food production have improved our ability to treat diseases
              and produce large amounts of food. Yet, chronic conditions such as metabolic disorders,
              cardiovascular diseases, and inflammatory illnesses continue to arise when regulatory
              systems are disrupted.
            </p>

            <p className="rm-subtext">They reflect altered,</p>

            <ul className="rm-bullets">
              <li>Gut function</li>
              <li>Impaired lipid handling</li>
              <li>Inflammatory signaling</li>
              <li>Cellular stress</li>
            </ul>

            <p className="rm-gap-statement">This reflects a growing health and nutrition gap.</p>

            <p>
              In healthcare, many treatments are designed to manage symptoms and control disease
              progression, but they often do not address underlying factors. At the same time,
              modern foods frequently emphasize convenience and processed foods, providing enough
              calories but often lacking the nutrient diversity and plant compounds that support
              optimal biological function.
            </p>

            <p>
              Together, they create a gap between treating disease and supporting health at its
              foundation — a gap that highlights the importance of understanding and improving
              the foods we consume.
            </p>

            <blockquote className="rm-quote">
              "Bridging the gap begins with understanding the biology of what we eat."
            </blockquote>

            <button className="rm-back-btn" onClick={onClose}>Back to Home</button>
          </div>

          {/* Right — Image */}
          <div className="rm-image">
            <img
              src="https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-2.png"
              alt="The Modern Health and Nutrition Gap"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestorationModal;
